/**
 * REQUISITOS DE ASEGURABILIDAD DE VIDA
 * Vigente a partir del 1° de Noviembre del 2016
 */
export * from '@constants/requirements/exchange-rate/exchange-rate.constant';
export * from '@constants/requirements/financial/financial.constant';
export * from '@constants/requirements/medical/medical.constant';
export * from '@constants/requirements/notes/notes.constant';
